import { render, staticRenderFns } from "./CardProductDetail.vue?vue&type=template&id=0ac81626"
import script from "./CardProductDetail.vue?vue&type=script&lang=js"
export * from "./CardProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports